import { types } from "@/content/samples/types";
import { levels } from "@/content/samples/levels";
import { formats } from "@/content/samples/formats";
import { SelectedValues } from "@/utils/usePageFIlters";

export type FilterFormProps = {
  selectedValues: SelectedValues;
  onChange: Function;
};

type OptionType = {
  name: string;
  value: string;
};

const getAdditionalFields = (subjects: OptionType[], essayTypes: OptionType[], topics: OptionType[]) => [
  {
    label: "Subject",
    placeholder: "Select subject",
    name: "idSubcategory" as const,
    type: "select",
    options: subjects,
  },
  {
    label: "Essay type",
    placeholder: "Select type",
    name: "idEssayType" as const,
    type: "select",
    options: essayTypes,
  },
  {
    label: "Topic",
    placeholder: "Select topic",
    name: "idTag" as const,
    type: "select",
    options: topics,
  },
];

const BASIC_FIELDS = [
  {
    label: "Assignment types",
    placeholder: "Select type",
    name: "idPaperType" as const,
    type: "select",
    options: types,
  },
  {
    label: "Academic level",
    placeholder: "Select level",
    name: "idAcademicLevel" as const,
    type: "select",
    options: levels,
  },
  {
    label: "Format",
    placeholder: "Select format",
    name: "idPaperFormat" as const,
    type: "select",
    options: formats,
  },
];

export type FormFieldParams =
  | { set: "basic" }
  | { set: "extended"; subjects: OptionType[]; essayTypes: OptionType[]; topics: OptionType[] };

export const getFilterFormFields = (params: FormFieldParams) =>
  params.set === "basic"
    ? BASIC_FIELDS
    : [...getAdditionalFields(params.subjects, params.essayTypes, params.topics), ...BASIC_FIELDS];
